import React from 'react';
import {ContentWrapper, SelectButton, TooltipDiv} from './DisclaimerPicker.style';
import {DisclaimerDTO} from '../../models/dto/DisclaimerDTO';
import {t} from 'i18next';
import {NO_DISCLAIMER_KEY, WATERMARK} from '../../init/constants';
import {isNullOrEmpty, isWatermarkApplicableCheck} from '../../utils';

export interface DisclaimerPickerProps {
    readonly dataSource: DisclaimerDTO[];
    readonly disclaimer: string;
    readonly watermark: boolean;
    onChange: (disclaimer: (string)) => void;
}

/**
 * @name DisclaimerPicker
 * @description
 * Component to make a selection of disclaimer to show in disclaimer popup before download
 */
export const DisclaimerPicker: React.VFC<DisclaimerPickerProps> = (props) => {
    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        let eventValue = e.target.value.toString();
        props.onChange(eventValue);
    };

    const isSelected = (value: string): boolean => {
        if (!props.watermark && props.disclaimer.toLowerCase().includes(WATERMARK.toLowerCase())) {
            props.onChange(NO_DISCLAIMER_KEY);
            return false;
        } else if (isWatermarkApplicableCheck(props.watermark) && (!(props.disclaimer.toLowerCase().includes(WATERMARK.toLowerCase()) || props.disclaimer.toLowerCase().includes(NO_DISCLAIMER_KEY.toLowerCase())))) {
            props.onChange(NO_DISCLAIMER_KEY);
            return false;
        } else if (!isNullOrEmpty(props.disclaimer)) {
            return (props.disclaimer === value);
        } else {
            return false;
        }
    };

    const isDisable = (value: string): boolean => {
        if ((!value.toLowerCase().includes(WATERMARK.toLowerCase()))
            && (!value.toLowerCase().includes(NO_DISCLAIMER_KEY.toLowerCase()))
            && isWatermarkApplicableCheck(props.watermark)) {
            return true;
        } else if ((!value.toLowerCase().includes(WATERMARK.toLowerCase()))) {
            return false;
        } else {
            return (!isWatermarkApplicableCheck(props.watermark));
        }
    };

    return (
        <ContentWrapper>
            {props.dataSource.map(discData => {
                return <TooltipDiv key={discData.disclaimerKey}
                                   data-tooltip={discData.disclaimerText}>
                    <SelectButton
                        data-testid='disclaimerInput'
                        name='disclaimer'
                        id={discData.disclaimerKey}
                        label={discData.disclaimerType}
                        value={discData.disclaimerKey}
                        disabled={isDisable(discData.disclaimerKey)}
                        checked={isSelected(discData.disclaimerKey)}
                        onChange={handleInput}
                    />
                </TooltipDiv>
            })}
            <SelectButton
                data-testid='disclaimerInput'
                name='disclaimer'
                id={NO_DISCLAIMER_KEY}
                label={t('NO_DISCLAIMER_SELECTED')}
                value={NO_DISCLAIMER_KEY}
                disabled={isDisable(NO_DISCLAIMER_KEY)}
                checked={isSelected(NO_DISCLAIMER_KEY)}
                onChange={handleInput}
            />
        </ContentWrapper>
    );
};
